<template>
  <div
    class="relative flex px-3 items-center border-b border-b-gray-100 focus:border-gray-100"
    :class="{
      'bg-gray-100 rounded': standalone,
    }"
  >
    <MagnifyingGlassIcon
      class="absolute h-4 w-4 text-gray-500 pointer-events-none"
      aria-hidden="true"
    />
    <input
      ref="input"
      @keydown="onKeyDown"
      type="text"
      class="block w-full border-0 py-1.5 pl-6 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
      :class="{
        'bg-gray-100': standalone,
      }"
      :placeholder="props.placeholder"
      @input="emit('update:modelValue', $event.target.value)"
      :value="props.modelValue"
    />
    <XMarkIcon
      v-if="modelValue?.length > 0"
      @click="clear"
      class="h-4 w-4 text-gray-500 cursor-pointer"
      aria-hidden="true"
    />
  </div>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from "vue";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/vue/20/solid";
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: String,
  placeholder: String,
  standalone: Boolean,
});

const { isMobile } = useBreakpoints();

const clear = () => {
  emit("update:modelValue", "");
  focus();
};

onMounted(() => {
  clear();
});

const input = ref(null);

const focus = () => {
  if (isMobile.value) {
    return;
  }

  setTimeout(() => {
    input.value?.focus();
  }, 100);
};

/** Ensure space key doesn't interfere with Headless UI keyboard interaction. */
const onKeyDown = (e) => {
  if (e.code === "Space") {
    e.stopPropagation();
  }
};

defineExpose({ focus, clear });
</script>
